// Google Ads / paid landing pages config.
// Each LP is a focused, distraction-light conversion page tied to a specific keyword cluster.
// No site nav, no footer links — just headline, proof, lead form CTA, WhatsApp + Phone.

export const LANDING_PAGES = {
  "health-claim-rejected": {
    title: "Health Claim Rejected? Don't Give Up.",
    subtitle: "Independent claim advisors who reverse wrongful health insurance rejections — 6 in 10 reversed at the insurer level.",
    keyword: "health insurance claim rejected",
    accent: "emerald",
    hero: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=1200&q=70",
    bullets: [
      "Free review of your rejection letter within 24 hours",
      "Re-built medical chronology + doctor clarifications",
      "Structured representation citing IRDAI master circular",
      "Internal Ombudsman and Insurance Ombudsman support",
    ],
    stats: [
      { value: "60%", label: "Wrongful rejections we reverse" },
      { value: "48 hrs", label: "Initial expert opinion" },
      { value: "₹120 Cr+", label: "Settlements supported" },
    ],
    proof: "Recent case: ₹4.2L mediclaim rejected as 'pre-existing' — full settlement within 6 weeks after our representation.",
    primaryCta: "Get my claim reviewed — free",
    formTitle: "Tell us about your rejection",
  },
  "motor-claim-help": {
    title: "Motor Claim Short-settled or Delayed?",
    subtitle: "An independent second look at your motor claim — surveyor report analysis, deduction reconciliation and structured representation.",
    keyword: "motor insurance claim help",
    accent: "navy",
    hero: "https://images.unsplash.com/photo-1605152276897-4f618f831968?auto=format&fit=crop&w=1200&q=70",
    bullets: [
      "Surveyor report review (depreciation, salvage, betterment)",
      "Policy-wording reconciliation line-by-line",
      "Direct representation to the insurer + Ombudsman",
      "Average uplift on short settlements we have seen: 28–40%",
    ],
    stats: [
      { value: "32%", label: "Average uplift on short settlements" },
      { value: "5,000+", label: "Cases advised" },
      { value: "20+ yrs", label: "Industry experience" },
    ],
    proof: "Recent case: ₹3.4L motor claim, insurer settled ₹2.1L. After our representation — final cheque ₹2.9L.",
    primaryCta: "Review my motor claim",
    formTitle: "Send us your motor claim details",
  },
  "claim-advisor-ahmedabad": {
    title: "Insurance Claim Advisor in Ahmedabad.",
    subtitle: "Walk into our Ashram Road office or work entirely online. Independent claim advisory for Ahmedabad and across Gujarat.",
    keyword: "insurance claim consultant ahmedabad",
    accent: "gold",
    hero: "https://images.unsplash.com/photo-1672380135241-c024f7fbfa13?auto=format&fit=crop&w=1200&q=70",
    bullets: [
      "Office at Ratna Business Square, Ashram Road",
      "Free in-person or video consultation",
      "Health, motor, life, property and commercial claims",
      "Dedicated case manager for every client",
    ],
    stats: [
      { value: "20+ yrs", label: "Experience" },
      { value: "Ahmedabad", label: "Office HQ" },
      { value: "92%", label: "Resolution success rate" },
    ],
    proof: "Recommended by hospital administrators and HR teams across Gujarat for claim resolution.",
    primaryCta: "Book a free consultation",
    formTitle: "Schedule a consultation",
  },
  "free-claim-review": {
    title: "Free Insurance Claim Review.",
    subtitle: "An independent expert opinion on your claim within 48 hours — no obligation, no charges for the first review.",
    keyword: "free insurance claim review",
    accent: "navy",
    hero: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=70",
    bullets: [
      "Free review within 48 working hours",
      "Senior advisor with 20+ years experience",
      "Transparent fixed fees — only if you choose to engage",
      "Independent — we do not sell insurance",
    ],
    stats: [
      { value: "Free", label: "First consultation" },
      { value: "48 hrs", label: "Turnaround" },
      { value: "5,000+", label: "Claims advised" },
    ],
    proof: "Across thousands of reviews, we have found that nearly 4 in 10 rejected or short-settled claims are challengeable.",
    primaryCta: "Get my free review",
    formTitle: "Send your claim for free review",
  },
};
